import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  hide() {
    if (this.panelTarget.matches(":popover-open")) {
      this.panelTarget.hidePopover()
    }
  }
}
